import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { useLang } from "../context/LangContext";

const PHONE = "35799574428"; // +357 99574428
const MESSAGES = {
  en: "Hi MP Sound — I'd like to ask about ",
  gr: "Γεια σας — θα ήθελα να ρωτήσω για ",
};

export default function WhatsAppFab() {
  const { lang } = useLang();
  const text = encodeURIComponent(MESSAGES[lang] || MESSAGES.en);
  const href = `https://wa.me/${PHONE}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 left-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 group-hover:opacity-70 blur-xl transition-opacity" />
      <span className="relative flex items-center gap-2 bg-[#25D366] text-black font-bold px-5 py-3 mono-font text-xs uppercase tracking-widest shadow-2xl hover:bg-[#1ebe5b] transition-colors">
        <WhatsappLogo size={22} weight="fill" />
        <span className="hidden sm:inline">{lang === "gr" ? "Chat" : "Chat"}</span>
      </span>
    </a>
  );
}
